import { OK } from 'http-status-codes'
import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class SinCupo {
  static getSinCupo () {
    const orden = '{"orden": ["fecha_de_ingreso"]}'
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_cola_sin_cupo_listado?r=${orden}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado de camiones sin cupo.')
      return data
    })
  }

  static ingresarSinCupo (numero) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`colasincupo?r=` +
     `{"clave": {"numero": ${numero}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => { return result })
  }

  static ingresarSinCupoPorCereal (cereal) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`colasincupo_borrar_por_cereal?r=` +
     `{"clave": {"cereal": "${cereal}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => { return result })
  }
}

export default SinCupo
